import { filterTypes } from '../settings/types'

export const setItems = data => ({
    type: filterTypes.items,
    payload: data
})

export const setFilterInfo = data => ({
    type: filterTypes.filter,
    payload: data
})

export const setTableInfo = data => ({
    type: filterTypes.tableInfo,
    payload: data
})

export const changeLoadDataStatus = data => ({
    type: filterTypes.loadData,
    payload: data
})

export const clearFilters = () => ({
    type: filterTypes.clear,
})

export const removeItem = data => ({
    type:filterTypes.removeItem,
    payload: data
})

export const addItem = data => ({
    type:filterTypes.addItem,
    payload: data
})

export const changeListItem = data => ({
    type: filterTypes.changeItem,
    payload: data
})